import React from 'react';
import { Helmet } from "react-helmet"
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
// Global styles and component-specific styles.
// import "./global.css"
// import styles from "./main.module.css"
import styled, { createGlobalStyle } from 'styled-components';

import Header from '../Header';
import Footer from '../Footer';

const GlobalStyles = createGlobalStyle`
  :root {
    font-size: 10px;
  }

  html {
    scroll-behavior: smooth;
  }
  
  body {
    font-family: 'Poppins', sans-serif;
    margin: 0;
    font-size: 1.6rem;
    color: rgba(0, 0, 0, 0.7);
    background-color: #fcfcfc;
    scroll-behavior: smooth;
  }
`;

const Main = styled.main`
  min-height: 90vh;
`

const Layout = ({ location, children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet title={data.site.siteMetadata.title} />
        <Header logo={location} />
        <Main>
          {children}
        </Main>
        <Footer />
        <GlobalStyles />
      </>
    )}
  />
);

Layout.defaultProps = {
  location: null,
};

Layout.propTypes = {
  location: PropTypes.any,
  children: PropTypes.node.isRequired,
};

export default Layout;




// const Layout = ({ children }) => (
//   <div>
//     <Helmet title="Gatsby Simple Firebase Authentication" />
//     <Header />
//     <main className={styles.main}>{children}</main>
//   </div>
// )
